// ============================================================
// CONFIGURATION DU SITE — MODE "studio" ou "films"
// ------------------------------------------------------------
// Pour transformer ce site en site FENEK FILMS :
//   1. frontend/.env  -> REACT_APP_SITE_MODE=films
//   2. backend/.env   -> SITE_MODE=films
//   3. supervisorctl restart backend frontend
// ============================================================

const SITE_CONFIG = {
  studio: {
    mode: "studio",
    studioType: "enregistrement",
    brandFirst: "FNK",
    brandSecond: "STUDIO",
    fullName: "FNK STUDIO",
    logo: "/logo-fenek-studio.jpg",
    headerLogo: "/logo-fenek-head.jpg",
    subtitle: "Enregistrement · Mix · Master · Beatmaking",
    heroTitleA: "Votre espace",
    heroTitleAccentA: "créatif",
    heroTitleB: "pour donner vie à tous",
    heroTitleAccentB: "vos projets musicaux.",
    heroText:
      "Enregistrement, mix, master et beatmaking dans un studio professionnel équipé, ouvert 24h/24.",
    heroImg:
      "https://images.unsplash.com/photo-1517273006195-51fa3364bce2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjByZWNvcmRpbmclMjBzdHVkaW8lMjBtaXhpbmclMjBjb25zb2xlJTIwZGFya3xlbnwwfHx8YmxhY2t8MTc4Mzg5MzcxNHww&ixlib=rb-4.1.0&q=85",
    heroAlt: "Console de mixage FNK STUDIO",
    footerDesc: "FNK STUDIO : enregistrement, mix, master et beatmaking. Ouvert 24h/24 — 7j/7.",
  },
  films: {
    mode: "films",
    studioType: "media",
    brandFirst: "FNK",
    brandSecond: "FILMS",
    fullName: "FNK FILMS",
    logo: "/logo-fenek-films.jpg",
    headerLogo: "/logo-fenek-films.jpg",
    subtitle: "Mariages · Clips · Podcasts · Photo · Book · Interviews",
    heroTitleA: "Capturer l'émotion,",
    heroTitleAccentA: "sublimer l'image.",
    heroTitleB: "Production photo & vidéo",
    heroTitleAccentB: "professionnelle.",
    heroText:
      "Clips, mariages, podcasts, books photo et films d'entreprise. Une équipe de passionnés, un local photo professionnel entièrement équipé — à votre service 24h/24 – 7j/7.",
    heroImg: "/hero-films.jpg",
    heroAlt: "Cadreur filmant avec un Sony A7 IV sur plateau FNK FILMS",
    footerDesc:
      "FNK FILMS : mariages, clips, podcasts, photo, book et interviews. Des passionnés de l'image à votre service, 24h/24 — 7j/7.",
  },
};

const rawMode = (process.env.REACT_APP_SITE_MODE || "studio").toLowerCase();
export const SITE_MODE = rawMode === "films" ? "films" : "studio";
export const SITE = SITE_CONFIG[SITE_MODE];
export const IS_STUDIO = SITE_MODE === "studio";
export const SITE_STUDIO_TYPE = SITE.studioType;
